import type { ApiClientKind } from '@/api/client'

/**
 * The React Query keys the website connector cards read, defined once so a
 * `useQuery` and anything that later invalidates it cannot drift apart.
 */
export const websiteHealthKeys = {
  websites: (kind: ApiClientKind) => ['connector-websites', kind] as const,
  health: (websiteId: string, kind: ApiClientKind) => ['website-health', websiteId, kind] as const,
}
